export const environment = {
  production: true,
  ngxsPlugins: []
};
